import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export const unexpectedAssetsApi = (builder: BuilderType) => ({
  updateBatteryLocation: builder.mutation<unknown, { assetId: number }>({
    query: ({ assetId }) => ({
      url: `service/am-locations/batteries/${assetId}`,
      method: 'PUT',
    }),
    invalidatesTags: [projectsCacheTags.FLEETS, projectsCacheTags.RESOURCES],
  }),

  updateBatterySerial: builder.mutation<any, any>({
    query: (batteries) => ({
      url: `service/am-unexpected-assets/update`,
      method: 'PUT',
      body: { assets: batteries },
    }),
    invalidatesTags: [projectsCacheTags.RESOURCES],
  }),
});
